var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('h1',[_vm._v("Email Signature Generator")]),_c('SignatureForm')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }